var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarnaMadrassa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.832 24.5C48.832 37.7548 38.0869 48.5 24.832 48.5C11.5772 48.5 0.832031 37.7548 0.832031 24.5C0.832031 11.2452 11.5772 0.5 24.832 0.5C38.0869 0.5 48.832 11.2452 48.832 24.5Z",
    fill: "#CAD6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6481 19.4368C27.5637 19.4368 29.1165 17.884 29.1165 15.9684C29.1165 14.0529 27.5637 12.5 25.6481 12.5C23.7326 12.5 22.1797 14.0529 22.1797 15.9684C22.1797 17.884 23.7326 19.4368 25.6481 19.4368Z",
    fill: "#021922"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2384 28.8073L24.3841 25.6321C26.9109 26.8783 29.6237 26.3341 32.0843 24.983C33.0434 24.4565 33.3946 23.2512 32.8672 22.2922C32.3397 21.3333 31.1369 20.9814 30.1759 21.5088C27.2477 23.1178 25.7812 22.0904 25.1671 21.3358C24.871 20.5503 24.2582 19.8896 23.4065 19.5825C21.8572 19.0241 20.1578 19.8254 19.6005 21.3699L17.4328 27.3776C16.7462 29.2827 18.1283 31.329 20.1896 31.3569L21.3269 32.5362H17.8139C16.7195 32.5361 15.832 33.4236 15.832 34.5181C15.832 35.6126 16.7195 36.5 17.8139 36.5H25.9894C27.7305 36.5 28.6285 34.3998 27.4168 33.1424L23.2384 28.8073Z",
    fill: "#021922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarnaMadrassa);
export default __webpack_public_path__ + "static/media/Barna Madrassa.3332c54619884ebad8ef70db13f68580.svg";
export { ForwardRef as ReactComponent };